const enabledCategoryIds = (expensePolicy = {}) =>
	new Set(
		Object.entries(expensePolicy)
			.filter(([, rule]) => rule?.enabled === true)
			.map(([key]) => Number(String(key).split("-")[0]))
			.filter((id) => Number.isInteger(id) && id > 0)
	);

export const claimableExpenseCategories = (categories = [], expensePolicy = {}) => {
	const enabledIds = enabledCategoryIds(expensePolicy);
	return categories.filter((category) => !category?.disabled && !category?.deleted && enabledIds.has(Number(category.id)));
};
